module.exports = __webpack_public_path__ + "static/media/61.34c4dc1e.png";